import dayjs, {Dayjs} from 'dayjs';

import {NZ_TIMEZONE} from 'globals/app-globals';

const parseDateAsNZTimezone = (date: string): Dayjs =>
  dayjs.tz(date, NZ_TIMEZONE);

export default parseDateAsNZTimezone;
